import { render, staticRenderFns } from "./ExpressedAs.vue?vue&type=template&id=baf675e4&scoped=true"
import script from "./ExpressedAs.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpressedAs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExpressedAs.vue?vue&type=style&index=0&id=baf675e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf675e4",
  null
  
)

export default component.exports